// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__3D8O8","content":"RecentSearches_content__1DtsI"};